import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CTAButton } from './CTAButton';
import { Lock, ShieldAlert } from 'lucide-react';
import { trackAddToCart } from '../lib/metaPixel';
export function Pricing() {
  return <SectionWrapper id="comprar" className="bg-brand-darker relative" data-id="element-157">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-brand-green/5 via-brand-darker to-brand-darker pointer-events-none" data-id="element-158"></div>

      <div className="container mx-auto px-4 max-w-3xl relative z-10" data-id="element-159">
        <div className="bg-brand-card border-2 border-brand-green rounded-3xl p-8 md:p-12 text-center shadow-[0_0_50px_rgba(0,255,148,0.1)]" data-id="element-160">
          <div className="inline-flex items-center gap-2 bg-red-500/10 text-red-400 px-4 py-2 rounded-full text-sm font-bold mb-8" data-id="element-161">
            <ShieldAlert className="w-4 h-4" data-id="element-162" />
            NO PAGUES $2,000 A UN ABOGADO
          </div>

          <h2 className="text-4xl md:text-5xl font-display uppercase text-white mb-6" data-id="element-163">
            Obtén el Sistema Completo
          </h2>

          <p className="text-xl text-gray-400 mb-8" data-id="element-164">
            No necesitas pagarle a un abogado. Tampoco necesitas suscripciones
            mensuales infinitas.
          </p>

          <div className="flex flex-col items-center justify-center mb-10" data-id="element-165">
            <span className="text-gray-500 line-through text-2xl font-bold mb-2" data-id="element-166">
              Valor Real: $27.00
            </span>
            <div className="flex items-start justify-center gap-1" data-id="element-167">
              <span className="text-3xl text-brand-green font-bold mt-2" data-id="element-168">
                $
              </span>
              <span className="text-7xl md:text-8xl font-display text-brand-green text-glow leading-none" data-id="element-169">
                6
              </span>
              <span className="text-xl text-brand-green font-bold mt-2" data-id="element-170">
                .39
              </span>
            </div>
            <span className="text-white font-bold uppercase tracking-widest mt-4 bg-brand-dark px-4 py-1 rounded border border-gray-800" data-id="element-171">
              Pago Único
            </span>
          </div>

          <CTAButton className="w-full max-w-md mx-auto" text="OBTÉN TU SISTEMA COMPLETO AHORA" href="https://www.p2ptdigitalsystems.com/cart/45246022156495:1" external onClick={() => trackAddToCart({
          content_name: 'Crédito Maestro 2026',
          content_type: 'product',
          value: 6.39,
          currency: 'USD'
        })} data-id="element-172" />

          <div className="mt-8 flex items-center justify-center gap-2 text-gray-500 text-sm" data-id="element-173">
            <Lock className="w-4 h-4" data-id="element-174" />
            <span data-id="element-175">Transacción encriptada de 256-bits</span>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}